import {
  HttpDeleteRequest,
  HttpGetRequest,
  HttpPostRequest,
  HttpPutRequest,
} from "./HttpRequest.js";

export async function create(patient) {
  let url = "/patient";
  return await HttpPostRequest(url, patient).then((response) => {
    return response.json();
  });
}

export async function update(id, patient) {
  let url = "/patient/" + id;
  return await HttpPutRequest(url, patient).then((response) => {
    return response.json();
  });
}

export async function getOne(patientId) {
  let url = "/patient/" + patientId;
  return await HttpGetRequest(url).then((response) => {
    return response.json();
  });
}

export async function all(payload) {
  let url = "/patients";
  return await HttpPostRequest(url, payload).then((response) => {
    return response.json();
  });
}

export async function remove(patientId) {
  let url = "/patient/" + patientId;
  return await HttpDeleteRequest(url).then((response) => {

    if (response.status === 200) {
      return response.json();
    }
  
    return Promise.reject(new Error(response));
  });
}
